import { render, staticRenderFns } from "./OrganizationJoinStep2.vue?vue&type=template&id=0ea771dc&"
import script from "./OrganizationJoinStep2.vue?vue&type=script&lang=js&"
export * from "./OrganizationJoinStep2.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationJoinStep2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports